export const url = 'vendedor';
export const titles = {
  main: 'VDI',
  module: 'Vendedores',
  list: 'Lista de vendedores',
  edit: 'Editar vendedor'
}
export const messages = {
  update: '¿Está seguro que desea actualizar el siguiente elemento?',
}
